/* eslint-disable camelcase */
import router from '../../../router'
import { getWithComplexStingPath, setWithComplexStringPath } from '../../../utils/utils'
import { SPORTS_BY_ID } from '../../../components/pages/TraderMode/utils/sportsById'
import { getWindowPosition } from './utils'

export default API => ({
  openTraderWindow (store, { id, translation, hasMarketSettingsAbility }) {
    const { windows } = store.state
    const { sport_id: sportId, booking } = translation
    const hasMarkets = booking && booking.booked_market && hasMarketSettingsAbility

    let url = `${!SPORTS_BY_ID[sportId] ? 'old/' : ''}#/trader/detail/${id}`

    const { width, height, left } = getWindowPosition(windows, hasMarkets)

    let newWindow = window.open(url, `traderMode${id}`, `location=1,width=${width},height=${height},left=${left},resizable=no,scrollbars=no`)

    if (!newWindow) {
      alert('Please allow popups in your browser')

      return
    }

    newWindow.onload = function () {
      // сохраним в открытом окне id
      this.translationId = id

      newWindow.onbeforeunload = function () {
        let translationId = this.translationId

        store.dispatch('closeTraderWindow', translationId)
      }
    }

    // ловим закрытие окна

    store.commit('SET_TRADER_WINDOW', {
      id,
      window: newWindow,
      hasMarkets
    })
  },
  openTraderPopupPlayer (store, { id, streamName, sign }) {
    const popupUrl = `#/trader/video?streamName=${streamName}&sign=${sign}`

    let newWindow = window.open(popupUrl, `traderVideo${id}`, `location=1,width=${720},height=${415},left=${0},resizable=no,scrollbars=no`)

    if (!newWindow) {
      alert('Please allow popups in your browser')

      return
    }

    newWindow.onload = function () {
      // сохраним в открытом окне id
      this.translationId = id

      newWindow.onbeforeunload = function () {
        let translationId = this.translationId

        store.dispatch('closeTraderPopupPlayer', translationId)
      }
    }

    store.commit('SET_TRADER_POPUP_PLAYER', {
      id,
      streamName,
      sign
    })
  },
  closeTraderWindow (store, id) {
    store.commit('DELETE_TRADER_WINDOW', id)
  },
  closeTraderPopupPlayer (store, id) {
    store.commit('DELETE_TRADER_POPUP_PLAYER', id)
  },
  setHeaderExtraTitle (store, { value, checkParam, defaultTitle }) {
    const { currentRoute } = router

    if (value) {
      store.commit(
        'SET_EXTRA_TITLE',
        value === 'all'
          ? ''
          : value
      )
      return
    }

    if (!checkParam) {
      store.commit('SET_EXTRA_TITLE', '')

      return
    }

    const currentCheckParam = getWithComplexStingPath(currentRoute, checkParam)

    if (!currentCheckParam) {
      router.push(setWithComplexStringPath({}, checkParam, defaultTitle)).catch((e) => {
        // eslint-disable-next-line
        console.log(e)
      })
    }

    let title = currentCheckParam || defaultTitle

    if (title === 'all') {
      title = ''
    }

    store.commit('SET_EXTRA_TITLE', title)
  },
  openPopAside (store, { title, component, data }) {
    if (!component) {
      console.error('Component is non defined')

      return
    }

    store.commit('OPEN_POP_ASIDE', { title, component, data })
  },
  closePopAside (store) {
    store.commit('CLOSE_POP_ASIDE')
  },
  async getEventsTypes (store) {
    try {
      const { data } = await API.getEventTypes()
      const sportEvents = {}
      const defaultEvents = {}

      data.forEach(event => {
        const { sports, event_code, displayed } = event

        if (!displayed) return

        if (!sports || !sports.length) {
          defaultEvents[event_code] = event

          return
        }

        if (!sportEvents[event_code]) {
          sportEvents[event_code] = event

          return
        }

        if (Array.isArray(sportEvents[event_code])) {
          sportEvents[event_code].push(event)

          return
        }

        sportEvents[event_code] = [sportEvents[event_code], event]
      })

      store.commit('SET_DEFAULT_EVENTS', defaultEvents)
      store.commit('SET_SPORT_EVENTS', sportEvents)
    } catch (err) {
      console.error(err)
    }
  },
  createNotification (store, { title, description, duration = 5 }) {
    const id = Symbol('id')

    store.commit('ADD_NOTIFICATION_TO_QUEUE', { id, title, description })

    setTimeout(() => {
      store.commit('REMOVE_NOTIFICATION_FROM_QUEUE', id)
    }, duration * 1000)
  },
  removeNotification (store, id) {
    store.commit('REMOVE_NOTIFICATION_FROM_QUEUE', id)
  }
})
